import { Card, Icon, Stack, useTheme } from "@mui/material";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import ActionButton from "../../../components/shared/ActionButton";
import {
    DefaultDarkMapStyles,
    DefaultMapStyles,
} from "../../../constants/ProjectConstants";
import { RootState } from "../../../slices/Store";

// updated
export default function ProjectDetailMap() {
    const mapContainer = useRef(null);
    const theme = useTheme();
    const map = useRef(null);

    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    useEffect(() => {
        if (map.current) return; // initialize map only once

        import("mapbox-gl").then((mapboxgl) => {
            try {
                mapboxgl.setRTLTextPlugin(
                    process.env.REACT_APP_MAP_STYLE_URL,
                    null
                );
            } catch {
                // ignore error in adding rtl
            }

            map.current = new mapboxgl.Map({
                container: mapContainer.current,
                style:
                    theme.palette.mode === "light"
                        ? DefaultMapStyles
                        : DefaultDarkMapStyles,
                center: [
                    projectDetailState.projectDetail.longitude,
                    projectDetailState.projectDetail.latitude,
                ],
                zoom: 12,
            });

            new mapboxgl.Marker()
                .setLngLat([
                    projectDetailState.projectDetail.longitude,
                    projectDetailState.projectDetail.latitude,
                ])
                .addTo(map.current);
        });
    });

    useEffect(() => {
        return () => {
            map.current?.remove();
        }
    }, []);

    if (!projectDetailState.projectDetail.latitude) {
        return <></>;
    }

    const openNavigationWithGoogle = () => {
        window.open(
            `https://www.google.com/maps/place/${projectDetailState.projectDetail.latitude},${projectDetailState.projectDetail.longitude}`
        );
    };

    const openNavigationWithWaze = () => {
        window.open(
            `https://www.waze.com/ul?q=${projectDetailState.projectDetail.latitude},${projectDetailState.projectDetail.longitude}&navigate=yes&zoom=17`
        );
    };

    const openShareLink = () => {
        navigator.share({
            url: `https://www.google.com/maps?q=${projectDetailState.projectDetail.latitude},${projectDetailState.projectDetail.longitude}`,
        });
    };

    return (
        <Stack direction="column" spacing={2}>
            <Card
                sx={{ height: "300px" }}
                ref={mapContainer}
                className="map-container"
            />

            <ActionButton
                onClick={openNavigationWithGoogle}
                icon={<Icon color="primary">navigation</Icon>}
                title="مسیر یابی با Google Maps"
            />

            <ActionButton
                onClick={openNavigationWithWaze}
                icon={<Icon color="primary">navigation</Icon>}
                title="مسیر یابی با Waze"
            />

            <ActionButton
                onClick={openShareLink}
                icon={<Icon color="primary">share</Icon>}
                title="به اشتراک گذاری موقعیت پروژه"
            />
        </Stack>
    );
}
